var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModerateFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moderate_icon",
    "data-name": "Moderate icon",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M254,388h14.359a.141.141,0,0,1,.141.141V402.5A14.5,14.5,0,0,1,254,417h0a14.5,14.5,0,0,1-14.5-14.5h0A14.5,14.5,0,0,1,254,388Z",
    transform: "translate(-239.5 -388)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(6.539 7.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M256.676,416.547a8.844,8.844,0,0,1-8.382-5.512l1.385-.541a7.645,7.645,0,0,0,13.994,0l1.385.541A8.844,8.844,0,0,1,256.676,416.547Z",
    transform: "translate(-248.294 -401.675)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M268.55,400.865h-1.487c0-.3-.647-.744-1.54-.744s-1.54.445-1.54.744H262.5c0-1.251,1.329-2.231,3.027-2.231S268.55,399.613,268.55,400.865Z",
    transform: "translate(-251.936 -398.634)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M254.55,400.865h-1.487c0-.3-.647-.744-1.54-.744s-1.54.445-1.54.744H248.5c0-1.251,1.33-2.231,3.027-2.231S254.55,399.613,254.55,400.865Z",
    transform: "translate(-248.346 -398.634)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerateFace);
export default __webpack_public_path__ + "static/media/moderateFace.c3bc8533b7237d5da006bd12fc0e69d2.svg";
export { ForwardRef as ReactComponent };